import { File } from './../../models/files/files.model';
import { FormField } from '../forms/formField.model';

export class BookingOffer {
  id: string;
  title: any;
  description: any;
  min_days: number;
  booking_holidays: Array<any>; // TODO: Proper Type
  booking_formfields: Array<FormField>;
  booking_items: Array<BookingItem>;
  email: string;
  [title: string]: any;

  constructor(options: any) {
    this.id = options.id;
    this.title = options.title;
    this.description = options.description;
    this.min_days = options.min_days;
    this.booking_items = options.booking_items;
    this.booking_holidays = options.booking_holidays;
    this.booking_formfields = options.booking_formfields;
    this.email = options.email;
  }
}

export class BookingItem {
  id: string;
  booking_offer_id: string;
  title: any;
  description: any;
  file: File;
  available: boolean;
  amount: number;
  default_price: number;
  item_bookings: Array<ItemBooking>;
  constructor(options: any) {
    this.id = options.id;
    this.booking_offer_id = options.booking_offer_id;
    this.title = options.title;
    this.description = options.description;
    this.file = options.file;
    this.available = options.available !== undefined ? options.available : true;
    this.amount = options.amount;
    this.default_price = options.default_price;
  }
}

export class BookingHoliday {
  id: string;
  date_from: any;
  date_to: any;

  constructor(options: any) {
    this.id = options.id;
    this.date_from = options.date_from;
    this.date_to = options.date_to;
  }
}

export class ItemBooking {
  id: string;
  date_from: any;
  date_to: any;
  booking_item_id: string;
  cancelled: boolean;
  cancelled_reason: string;

  constructor(options: any) {
    this.id = options.id;
    this.date_from = options.date_from;
    this.date_to = options.date_to;
    this.booking_item_id = options.booking_item_id;
    this.cancelled = options.cancelled;
    this.cancelled_reason = options.cancelled_reason;
  }
}
